import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  fetchUser,
  fetchUserLocations,
  setActiveLocation
} from "../../actions";
import Chip from "@material-ui/core/Chip";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus } from "@fortawesome/free-solid-svg-icons";

import Spinner from "../app/Spinner";
import Modal from "../app/Modal";
import LocationForm from "./LocationForm";

class Locations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      error: null,
      form: null,
      modalOpen: false,
      user: this.props.auth.email
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchUser());
    this.props.dispatch(fetchUserLocations(this.state.user));
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.props.dispatch(fetchUserLocations(this.state.user));
  };

  handleSelectLoc = (name, subscriptionId, subOid, isAdmin) => {
    if (name && subscriptionId) {
      this.props.dispatch(
        setActiveLocation(name, subscriptionId, subOid, isAdmin)
      );
    }
  };

  render() {
    // ***************************
    // ADD MENU FUNCTIONALITY
    const handleAddLocation = () => {
      this.setState({ form: "add", modalOpen: true });
    };

    const handleSelectLocation = e => {
      this.handleSelectLoc(
        this.props.userLocations[e.currentTarget.id].SubscriptionId.Business,
        this.props.userLocations[e.currentTarget.id].SubscriptionId
          .SubscriptionId,
        this.props.userLocations[e.currentTarget.id].SubscriptionId.Oid,
        this.props.userLocations[e.currentTarget.id].Admin
      );
      this.props.dispatch(fetchUserLocations(this.state.user));
    };

    const renderPlaceholder = () => {
      return <Spinner />;
    };

    const renderForm = type => {
      switch (type) {
        case "add":
          // return renderEditForm();
          return (
            <div>
              <LocationForm
                data=""
                subscriptionId={this.props.userLocations[0].SubscriptionId.Oid}
                userId={this.state.user}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
              />
            </div>
          );
        default:
          return renderPlaceholder();
      }
    };

    const renderResults = data => {
      let output = "";
      if (data) {
        output = data.map((record, index) => {
          let locationActive = (
            <button
              className="waves-effect waves-light btn btn-icon"
              onClick={handleSelectLocation}
              id={index}
            >
              Select
            </button>
          );
          let groupClasses = "group-thumbnail component-shadow";
          if (
            localStorage.getItem("SubscriptionId") ===
            record.SubscriptionId.SubscriptionId
          ) {
            locationActive = (
              <button className="waves-effect waves-light btn btn-icon btn-active">
                Active
              </button>
            );
            groupClasses = "group-thumbnail component-shadow group-active";
          }

          let isAdmin = "";
          if (record.Admin === true) {
            isAdmin = (
              <Chip label="Admin" color="primary" className="pull-right" />
            );
          }

          let editLink = "";
          if (record.Admin === true) {
            editLink = (
              <Link
                className="waves-effect waves-light btn btn-icon"
                to={`/locations/${record.SubscriptionId.SubscriptionId}/users`}
              >
                <FontAwesomeIcon icon={faPen} size="lg" />
              </Link>
            );
          }

          return (
            <div key={index} className={groupClasses}>
              <div className="group-details">
                <div className="group-name">
                  {record.SubscriptionId.Business || "Enter business name"}
                  &nbsp;
                  {isAdmin}
                </div>
                <div className="group-type">
                  {record.SubscriptionId.FullName}
                </div>
                <div className="group-type">{record.SubscriptionId.Email}</div>
                <div className="group-type">{record.SubscriptionId.Phone}</div>
              </div>
              <div className="group-actions">
                {editLink}
                &nbsp;
                {locationActive}
              </div>
            </div>
          );
        });
      }
      return output;
    };

    const renderContent = (
      <div className="component-group pad-20">
        <h1>Select Location</h1>
        <div className="component-actions">
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleAddLocation}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" /> Add Location
          </button>
        </div>
        <div>
          <div className="group-container">
            {renderResults(this.props.userLocations)}
          </div>
        </div>
        <div className="component-footer"></div>
      </div>
    );

    return (
      <div className="component-groups component-locations">
        {renderContent}
        <Modal modalOpen={this.state.modalOpen}>
          {renderForm(this.state.form, this.state.data)}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    session: state.session,
    userLocations: state.userLocations
  };
}

export default connect(mapStateToProps)(Locations);
